import api from "./api";

const ShoppingService = {
  async listProducts() {
    const r = await api.get("/shopping/products");
    return r.data;
  },
  async getProduct(id) {
    const r = await api.get(`/shopping/products/${id}`);
    return r.data;
  },
  async listAddresses(email) {
    const r = await api.get("/shopping/addresses", { params: { email } });
    return r.data;
  },
  async saveAddress(data) {
    const r = await api.post("/shopping/addresses", data);
    return r.data;
  },
  async updateAddress(id, data) {
    const r = await api.put(`/shopping/addresses/${id}`, data);
    return r.data;
  },
  async deleteAddress(id) {
    const r = await api.delete(`/shopping/addresses/${id}`);
    return r.data;
  },
  async placeOrder(data) {
    const r = await api.post("/shopping/orders", data);
    return r.data;
  },
  async listOrders(email) {
    const r = await api.get("/shopping/orders", { params: { email } });
    return r.data;
  },
};

export default ShoppingService;
